import React from 'react';
import './CloseButton.css';

export default function CloseButton(props) {
  return <button className={props.class} onClick={props.handleClose}></button>;
}
